import { useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FiArrowLeft, FiCheckCircle } from "react-icons/fi";
import { AccessLayout } from "./accessLayout";
import { resetPassword } from "../../api/login";

export default function RecoverPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [changed, setChanged] = useState(false);
  const [pending, setPending] = useState(false);
  const [visible, setVisible] = useState(false);
  const [error, setError] = useState("");
  const inFlight = useRef(false);
  const password = useRef(null);
  const submit = async (event) => {
    event.preventDefault();
    if (inFlight.current) return;
    if (!password.current.value) { setError("Introduce tu nueva contraseña."); return; }
    inFlight.current = true; setPending(true); setError("");
    try {
      const response = await resetPassword({ code: token, newPassword: password.current.value });
      if (response?.error === false) setChanged(true);
      else setError("No se ha podido actualizar la contraseña. El enlace puede haber caducado; solicita uno nuevo desde el inicio de sesión.");
    } catch { setError("No se pudo confirmar el cambio. Revisa la conexión y vuelve a intentarlo."); }
    finally { inFlight.current = false; setPending(false); }
  };
  return <AccessLayout title={changed ? "Contraseña actualizada" : "Crea tu nueva contraseña"} intro={changed ? "Ya puedes volver a iniciar sesión con tu nueva contraseña." : "Actualiza tu acceso de administración de Delibrán."}>
    {changed ? <div className="sa-code-help" role="status"><FiCheckCircle aria-hidden="true" /> Tu contraseña se ha actualizado correctamente.</div> : <form noValidate onSubmit={submit} aria-busy={pending}>
      <label className="labelLogin" htmlFor="passwordInput">Nueva contraseña · Obligatoria</label>
      <div className="sa-reset-password"><input ref={password} id="passwordInput" type={visible ? "text" : "password"} autoComplete="new-password" required disabled={pending} /><button type="button" className="sa-text-button" disabled={pending} aria-pressed={visible} onClick={()=>setVisible(!visible)}>{visible ? "Ocultar" : "Mostrar"}</button></div>
      {error && <p role="alert">{error}</p>}
      <button className="button-1" disabled={pending}>{pending ? "Actualizando…" : "Actualizar contraseña"}</button>
    </form>}
    <button className="sa-text-button sa-reset-back" disabled={pending} onClick={()=>navigate("/")}><FiArrowLeft aria-hidden="true" /> Volver al inicio de sesión</button>
  </AccessLayout>;
}
